@import "../../../css/_mixins.scss";

.modalTitle {
  font-weight: bold;
}

.btn {
  font-weight: bold;
  width: 100px;
  font-size: 16px;
  border-radius: 30px;
  padding-inline: 7px;
  height: 55px;
  float: right;
  margin-inline: 20px;
}

.modalYesBtn {
  width: auto + 10px;
  border: 3px solid var(--yellow);
  color: var(--yellow);
  padding-inline: 5px;
}

.modalNoBtn {
  padding-inline: 5px;
  font-size: 16px;
  border: 3px solid var(--yellow);
  color: var(--white);
  background-color: var(--yellow);
}

.container {
  display: flex;
  width: 100%;
  text-align: center;
  // The original 80vh min-height made this modal stretch to nearly the full
  // viewport which felt overwhelming. The content needs whatever vertical
  // space it actually uses — PayPal pads itself.

  @include small-desktop {
    flex-direction: column-reverse;
  }

  .content {
    position: relative;
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 32px 40px;

    @include small-desktop {
      padding: 28px 28px;
    }

    @include mobile {
      padding: 20px 14px;
    }

    .modalTitleLine {
      font-size: 20px;
      font-weight: 600;
      color: var(--gray);
      margin-bottom: 4px;
      letter-spacing: -0.2px;
    }

    .cartDetail {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 34px;
      font-weight: 700;
      letter-spacing: -0.5px;
      color: var(--red);
      margin-bottom: 8px;

      @include mobile {
        font-size: 28px;
      }

      i {
        margin-right: 10px;
        font-size: 40px;
        color: var(--red);
      }
    }

    .paymentLabel {
      font-size: 14px;
      color: var(--gray);
      margin: 16px 0 8px;
      text-align: center;
    }

    .description {
      margin: 20px 0 10px;
      font-size: 39px;
      line-height: 48px;
      color: var(--gray);
      text-align: center;
      font-weight: 500;
      letter-spacing: -0.78px;
    }

    .btnLogin {
      margin-top: 16px;
      width: 100%;
      max-width: 360px;
    }

    .checkoutButtons {
      margin-top: 8px;
      width: 100%;
      max-width: 360px;
      min-height: 60px;
    }

    .btnCorporateCheck {
      width: 100%;
      max-width: 360px;
      height: 45px;
      font-size: 18px;
      margin-top: 12px;
    }
  }

  .successModal {
    margin-left: -37px;
  }
}